/** Weekly buckets (jobs portal payout / stats charts). */
export const WEEKLY_TIMELINE_PRESETS = [
    { id: '5w', label: '1 month', weeks: 5 },
    { id: '13w', label: '3 months', weeks: 13 },
    { id: '26w', label: '6 months', weeks: 26 },
];

export const DEFAULT_WEEKLY_TIMELINE_WEEKS = 5;

/** Daily buckets (main dashboard payment chart). */
export const DAILY_TIMELINE_PRESETS = [
    { id: '14d', label: '2 weeks', days: 14 },
    { id: '30d', label: '1 month', days: 30 },
    { id: '90d', label: '3 months', days: 90 },
];

export const DEFAULT_DAILY_TIMELINE_DAYS = 30;

export function weeklyPresetLabel(weeks) {
    const match = WEEKLY_TIMELINE_PRESETS.find((p) => p.weeks === weeks);
    return match?.label || `${weeks} weeks`;
}

export function dailyPresetLabel(days) {
    const match = DAILY_TIMELINE_PRESETS.find((p) => p.days === days);
    return match?.label || `${days} days`;
}
